<div class="order-cell">
  <span class="label">
    {{ helperService.ColumnLabels.ORDER_DATE }} & {{ helperService.ColumnLabels.ORDER_TIME }}
  </span>
  <span class="cell-text">
    {{ order().orderedAt | luxonDate }}
    <span class="separator">|</span>
    {{ order().orderedAt | luxonDate: "T" }} Uhr
  </span>
</div>
<div class="order-cell">
  <span class="label">
    {{ helperService.ColumnLabels.DELIVERY_INFO }}
  </span>
  <span class="cell-text">
    @if (order().deliveryFrom && order().deliveryTo && order().deliveryFrom !== order().deliveryTo) {
      {{ order().deliveryFrom | luxonDate }}
      <span class="separator">|</span>
      {{ order().deliveryTo | luxonDate }}
    } @else if (order().deliveryFrom) {
      {{ order().deliveryFrom | luxonDate }}
    } @else if (order().deliveryTo) {
      {{ order().deliveryTo | luxonDate }}
    } @else {
      {{ helperService.ColumnLabels.NOT_SPECIFIED }}
    }
  </span>
</div>
<div class="order-cell">
  <span class="label">
    {{ helperService.ColumnLabels.ID_CUSTOMER_ORDER_NR }}
  </span>
  <span class="cell-text">
    @if (displayFullView()) {
      {{ invoiceNumber() }}
    } @else {
      <a [link]="orderLink()" [matTooltip]="helperService.ColumnLabels.SHOW_ORDER_RECORD" uiLink>
        {{ invoiceNumber() }}
      </a>
    }
    @if (orderNumber()) {
      <span class="separator">|</span>
      {{ orderNumber() }}
    }
  </span>
</div>
<div class="order-cell">
  <span class="label">
    {{ helperService.ColumnLabels.ORDER_STATUS }}
  </span>
  <span class="cell-text">
    <ui-order-history-status [orderStatus]="order().status"></ui-order-history-status>
  </span>
</div>
<div class="order-cell" *uiPriceVisibility>
  <span class="label">
    {{ helperService.ColumnLabels.NET }} & {{ helperService.ColumnLabels.GROSS }}
  </span>
  <span class="cell-text">
    {{ order().totals.net | number: '1.2-2' }} €
    <span class="separator">|</span>
    {{ order().totals.gross | number: '1.2-2' }} €
  </span>
</div>
<div class="order-cell">
  <span class="label">
    {{ helperService.ColumnLabels.POSITIONS }}
  </span>
  <span class="cell-text positions">
    <span>{{ order().positions }}</span>
    @if (order().positionsNotAvailable > 0) {
      <span class="not-available badge">
        {{ order().positionsNotAvailable }} {{ helperService.ColumnLabels.POSITIONS_NOT_AVAILABLE }}
      </span>
    }
    @if (order().positionsLimitedAvailable > 0) {
      <span class="limited-available badge">
        {{ order().positionsLimitedAvailable }} {{ helperService.ColumnLabels.POSITIONS_LIMITED_AVAILABLE }}
      </span>
    }
  </span>
</div>
<div class="order-cell">
  <span class="label">
    {{ helperService.ColumnLabels.ORDER_TYPE }}
  </span>
  <span class="cell-text">
    {{ orderType() }}
  </span>
</div>
<div class="order-cell full-width">
  <span class="cell-info">
    <ui-icon faName="circle-info" faStyle="light"></ui-icon>
    {{ helperService.ColumnLabels.AVAILABILITY_CHECK_INFO }}
  </span>
</div>
